import { API } from 'aws-amplify';
import { API_NAME, getConfig, handleError, validateResponse } from './apiUtils';

export function getRaffleReport(country, category, brand, fromDate, toDate) {
    const path = `/v1/loyaltyadmin/${country}/${category}/${brand}/report/raffle?fromDate=${fromDate}&toDate=${toDate}`;
    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function getWinnersReport(country, category, brand, fromDate, toDate) {
    const path = `/v1/loyaltyadmin/${country}/${category}/${brand}/report/prize-redeem?fromDate=${fromDate}&toDate=${toDate}`;
    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function getWinnersReportJson(country, category, brand, fromDate, toDate, options = {}) {
    let path = `/v1/loyaltyadmin/${country}/${category}/${brand}/report/prize-redeem-json?fromDate=${fromDate}&toDate=${toDate}`;

    if (options.gigyaId) {
        path += `&gigyaId=${options.gigyaId}`;
    }
    if (options.eventType) {
        path += `&eventType=${options.eventType}`;
    }
    if (options.start != null) {
        path += `&start=${options.start}`;
    }
    if (options.limit) {
        path += `&limit=${options.limit}`;
    }

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then((response) => {
            if (response.success !== true || !response.data?.results) {
                throw new Error('Invalid response from prize report API');
            }
            return response.data;
        })
        .catch(handleError);
}

export function getFreezeBlockReport(
    country,
    category,
    brand,
    fromDate,
    toDate,
    gigyaId = '',
    eventType = '',
    start = 0,
    limit = 10
) {
    let path = `/v1/loyaltyadmin/${country}/${category}/${brand}/freeze-block-history?fromDate=${fromDate}&toDate=${toDate}&start=${start}&limit=${limit}`;

    if (gigyaId) {
        path += `&gigyaId=${gigyaId}`;
    }

    if (eventType) {
        path += `&eventType=${eventType}`;
    }

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
